/**
 * @desc: 项目打款 API
 * @author: zengtiansheng
 * @update: 2018/3/20
 */
export default {
  noInvoiceApplyList: '/qtbCompanyCenter/invoice/foreign/project/not/invoiced/list', // 未开票项目列表获取
  invoiceList: '/qtbCompanyCenter/invoice/foreign/project/apply/list', // 发票管理页列表
  invoiceObtainInfo: '/qtbCompanyCenter/invoice/obtain/info', //获取账号的发票信息
  apiInvoiceApply: '/qtbCompanyCenter/invoice/foreign/project/apply', //发票申请
  addressList: '/qtbCompanyCenter/invoice/address/list', //获取发票地址信息
  apiInvoiceApplyCancel: '/qtbCompanyCenter/invoice/project/apply/calcel', //作废接口
  apiDistributeList: '/qtbForeignPayCenter/pc/company/order/list', // 接口发放列表
  exportSalaryExcel: '/qtbForeignPayCenter/pc/company/order/list/export', //工资支付明细导出接口

  projectAssistantList: '/qtbCompanyCenter/projectAssistant/list', //获取项目列表
  projectAssistantDel: '/qtbCompanyCenter/projectAssistant/del/id', //删除项目
  projectAssistantRecordList: '/qtbCompanyCenter/projectAssistantRecord/list', //项目账目列表
  exportExcel: '/qtbCompanyCenter/projectAssistantRecord/export/excel', //导出报表 a标签打开新页面获取
  importExcel: '/qtbCompanyCenter/projectAssistantRecord/load/excel', //项目助手模板Excel导入
  projectAssistantAdd: '/qtbCompanyCenter/projectAssistant/add', //添加项目
  addOneProjectRecord: '/qtbCompanyCenter/projectAssistantRecord/addPojectRecord', //项目单个添加人员
  updateProjectRecord: '/qtbCompanyCenter/projectAssistantRecord/update/pojectRecord', //项目未打款时 修改项目明细单条记录
  delOneProjectRecord: '/qtbCompanyCenter/projectAssistantRecord/del/poject/record', //删除账目
  orderProjectCreate: '/qtbCompanyCenter/projectAssistant/order/project/create', //项目创建订单接口
  loadExcel: '/qtbCompanyCenter/projectAssistantRecord/load/excel', //项目助手模板Excel导入
  createSingleOrder: '/qtbCompanyCenter/projectAssistant/order/project/record/create', //项目具体账目创建订单接口
  recordWithdraw: '/qtbCompanyCenter/projectAssistantRecord/withdraw/record', //商家撤回操作打款

  invoiceApplyList: '/qtbCompanyCenter/invoice/project/apply/list', //发票申请列表
  invoiceSubmitInfo: '/qtbCompanyCenter/invoice/submit/info', //添加发票信息
  addressDefaut: '/qtbCompanyCenter/invoice/address/defaut', //获取发票默认地址
  addressAdd: '/qtbCompanyCenter/invoice/address/add', //添加发票地址
  addressDel: '/qtbCompanyCenter/invoice/address/delete', //删除发票地址
  addressUpdate: '/qtbCompanyCenter/invoice/address/update', //更新发票地址
  invoiceApplyDetail: '/qtbCompanyCenter/invoice/project/apply/detail', //发票申请详情
  provinceList: '/qtbCompanyCenter/region/province/list', //获取省份列表
  townList: '/qtbCompanyCenter/region/town/list', //获取城市信息
  areaList: '/qtbCompanyCenter/region/area/list' //获取地区信息

}



// WEBPACK FOOTER //
// ./src/views/qtbaoAPI/API.js